<div mat-dialog-title>
    <div class="page-title-icon">
        <span class="card-header-value dialogue-tittle"> Analysis Request </span>
         <button mat-icon-button class="close-button" (click)="onClose()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
        <div class="subtitle">
            You have selected the following {{ selectedDataCount }} analyses.
            Please review your choices carefully and confirm your selection and consent by checking the box below.
        </div>
    </div>
</div>

<mat-dialog-content class="dialog-content">
    <div class="packages-container">
        <div *ngIf="data.selectedPackages && data.selectedPackages.length > 0; else noAnalysis">
            <div *ngFor="let pkg of data.selectedPackages" class="package-block">
                <h3 class="package-title">{{ pkg.packageName }}</h3>

                <div class="template-list">
                    <div *ngFor="let template of pkg.templateNames; let i = index" class="template-item">
                        <button mat-flat-button class="template-button">
                            {{ template }}
                        </button>
                        <button mat-icon-button color="grey" aria-label="Remove template" (click)="removeTemplate(pkg, i)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
        <ng-template #noAnalysis>
            <div class="no-analysis">
                No analysis selected!
            </div>
        </ng-template>
    </div>
</mat-dialog-content>

<div class="custom_checkbox">
    <mat-checkbox [(ngModel)]="isAnalysisReqReviewConsent" class="consent-checkbox-wrapper" [disabled]="!hasSelectedAnalyses">
        <span class="consent-text">
            I confirm that I give my consent for the selected analyses to be carried out
            on my whole genome data. I understand that the results will be used to
            generate my personal genomic report and that I may withdraw my consent for
            future analyses at any time.
        </span>
    </mat-checkbox>
</div>

<mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button (click)="onBack()">
        Back
    </button>
    <button mat-flat-button color="primary" [disabled]="!isAnalysisReqReviewConsent || !hasSelectedAnalyses" (click)="onConfirm()">
        Next
    </button>
</mat-dialog-actions>